import { i18nFn, ReferralsDTO, useSpringBigStore } from '@springbig/shared';
import { Box, VStack, HStack } from 'native-base';
import { CardTitle } from '~/pages/homePage/components/CardTitle';
import ReferRewards from '~/pages/refer/components/ReferRewards';
import ReferCopyLink from '~/pages/refer/components/ReferCopyLink';
import React from 'react';
import { useToast } from '~/hooks/toast';
import { useCopyToClipboard } from 'usehooks-ts';
import QrCode from '~/shared/QrCode';
import { useHomePageStyles, useReferStyles } from '~/shared/styles';
import { Caption } from '~/shared/Typography';

type ReferralsProps = {
    data: ReferralsDTO;
    t: i18nFn;
};

export const Referrals = ({
    data,
    t,
}: ReferralsProps) => {

    const { member } = useSpringBigStore();
    const { primary_color, pressable_text } = useHomePageStyles();
    const { qr_code_color } = useReferStyles();
    const { successToast } = useToast();
    const [value, copy] = useCopyToClipboard();

    const handleClipboard = (text: string) => {

        copy(text);
        successToast(t('home_page.referrals.copied_link'));
    };

    return (
        <VStack space={4}>
            <CardTitle
                title={t('home_page.referrals.title')}
                icon={'faShareAlt'}
            />
            <VStack space={4}>
                {
                    member &&
                    member.referrals.has_referred_offer &&
                    member.referrals.referred_offer_name && (
                        <ReferRewards member={member} />
                    )
                }
                <HStack alignItems={'center'} justifyContent={'space-around'}>
                    <VStack
                        alignItems={'center'}
                        bg={primary_color}
                        rounded={'lg'}
                        p={2}
                        space={2}
                        minW={24}
                        flex={1}
                    >
                        <Caption fontWeight={500}>
                            { t('home_page.referrals.referred') }
                        </Caption>
                        <Caption color={pressable_text}>
                            { data.referred_count }
                        </Caption>
                    </VStack>
                    <Box w={32} h={32} flex={2}>
                        <QrCode
                            color={qr_code_color}
                            size={170}
                            value={member && member.referrals?.link || 'www.google.com'}
                        />
                    </Box>
                    <VStack
                        alignItems={'center'}
                        bg={primary_color}
                        rounded={'lg'}
                        p={2}
                        space={2}
                        minW={24}
                        flex={1}
                    >
                        <Caption fontWeight={500}>
                            { t('home_page.referrals.offers_earned') }
                        </Caption>
                        <Caption color={pressable_text}>
                            { data.referred_rewards_count }
                        </Caption>
                    </VStack>
                </HStack>
            </VStack>
            <ReferCopyLink
                member={member}
                copyToClipboard={handleClipboard}
                link={t('home_page.referrals.copy_link')}
                rounded={'md'}
                isHideText={true}
            />
        </VStack>
    );
};
